import { createFileRoute } from '@tanstack/react-router'
import { GeckoInspectionWorkstationPage } from 'pages/geckoInspectionWorkstation/GeckoInspectionWorkstationPage'

export const Route = createFileRoute('/gecko-inspection-workstation/')({
  component: GeckoInspectionWorkstationPage,
  staticData: {
    title: 'Gecko Inspection Workstation',
  },
})
